import React from 'react';
import SelectedFilters from "./SelectedFilter";

const SearchForm = ({ value, inputHandler, submitHandler, selectedFilter, closeButtonHandler, keyStrokeHandler }) => {
  return <div className="facet-search">
    <form action="search">
      {value.length > 0 ? <div className="" span className="icon-close" onClick={() => inputHandler(null)} onKeyUp={keyStrokeHandler} /> : <></>}
      <input type="text" id="search" name="search" value={value} placeholder="Search for nominee..." onChange={(e) => inputHandler(e)} />
      <div className="submit-wrapper">
        <input type="submit" value="Submit" className="button" onClick={(e) => submitHandler(e)} />
      </div>
    </form>
    {window.innerWidth > 900 ?
      <SelectedFilters
        selectedFilter={selectedFilter}
        showCloseButton={value.length > 0}
        closeButtonHandler={closeButtonHandler}
      />
      : <></>}
  </div>
}

export default SearchForm;
